export var LabelAlign;
(function (LabelAlign) {
    LabelAlign["left"] = "left";
    LabelAlign["center"] = "center";
    LabelAlign["right"] = "right";
})(LabelAlign || (LabelAlign = {}));
export var LabelLayout;
(function (LabelLayout) {
    LabelLayout["horizontal"] = "horizontal";
    LabelLayout["vertical"] = "vertical";
    LabelLayout["placeholder"] = "placeholder";
    LabelLayout["float"] = "float";
    LabelLayout["none"] = "none";
})(LabelLayout || (LabelLayout = {}));
export var ResponsiveKeys;
(function (ResponsiveKeys) {
    ResponsiveKeys["xs"] = "xs";
    ResponsiveKeys["sm"] = "sm";
    ResponsiveKeys["md"] = "md";
    ResponsiveKeys["lg"] = "lg";
    ResponsiveKeys["xl"] = "xl";
    ResponsiveKeys["xxl"] = "xxl";
})(ResponsiveKeys || (ResponsiveKeys = {}));
